module.exports = __webpack_public_path__ + "img/password-lock.2fe2c5f4.svg";